import React, {useEffect, useState} from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import SwitchService from "../services/SwitchService";
import LinearProgress from '@mui/material/LinearProgress';
import {Box, Typography, useTheme} from "@mui/material";
import {tokens} from "../theme";
import { formatBps } from "../utils/formatNumbers";

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

const Speedtest = ({open, handleClose, params, interval=5000}) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [loading, setLoading] = useState(false);
    const [bitsReceived, setBitsReceived] = useState(0)
    const [bitsSent, setBitsSent] = useState(0)

    const descriptionElementRef = React.useRef(null);
    useEffect(() => {
        const fetcher = async (params) => {
            if (localStorage.getItem('token')) {
                setLoading(false)
                try {
                    const responseBitsStart = await SwitchService.getPortBits(params.fdb_network, params.sw_ip, params.sw_port)
                    var bitsReceivedStart = responseBitsStart.data.bits_received
                    var bitsSentStart = responseBitsStart.data.bits_sent
                    for (let i = 0; i < 10; i++) {
                        const responseBits = await SwitchService.getPortBits(params.fdb_network, params.sw_ip, params.sw_port)
                        setBitsReceived((responseBits.data.bits_received - bitsReceivedStart) / (interval / 1000))  
                        bitsReceivedStart = responseBits.data.bits_received
                        setBitsSent((responseBits.data.bits_sent - bitsSentStart) / (interval / 1000))   
                        bitsSentStart = responseBits.data.bits_sent
                        await sleep(interval)
                    }
                    setLoading(true)              
                } catch (e) {
                    console.log(e);
                }
            }
        };
        if (open) {
            fetcher(params)
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open,params]);

    return (
        <Box>
            <Dialog
                open={open}
                onClose={handleClose}
                scroll={'body'}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
            >
                <DialogTitle id="scroll-dialog-title">{Date().toLocaleString()}</DialogTitle>
                <DialogContent>
                    <DialogContentText
                        id="scroll-dialog-description"
                        ref={descriptionElementRef}
                        tabIndex={-1}
                        // p={5}
                    >
                        {loading
                                ? <Typography variant="h5" sx={{ color: colors.greenAccent[500] }}>Speedtest completed!!!</Typography>
                                : <LinearProgress /> }
                        <Box mt={2} ><Typography variant="h5" sx={{ color: colors.greenAccent[500] }}>{formatBps(bitsReceived * 8)} / {formatBps(bitsSent * 8)}</Typography></Box>
                        <Box></Box>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}
export default Speedtest;